import clientApi from './clientApi';
import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const clientAuthService = {
  checkCustomerCode: async (customerCode) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/check-customer-code`, { customer_code: customerCode });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to check customer code' };
    }
  },

  register: async (userData) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/register`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Registration failed' };
    }
  },

  verifyEmail: async (customerCode, verificationCode) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/verify-email`, {
        customer_code: customerCode,
        verification_code: verificationCode,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Verification failed' };
    }
  },

  resendVerification: async (customerCode) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/resend-verification`, { customer_code: customerCode });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to resend verification code' };
    }
  },

  login: async (email, password) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/login`, { email, password });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Login failed' };
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await axios.post(`${BASE}/api/client-auth/forgot-password`, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to process request' };
    }
  },

  getProfile: async () => {
    try {
      const response = await clientApi.get('/api/client-auth/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to get profile' };
    }
  },

  updateProfile: async (fullName) => {
    try {
      const response = await clientApi.put('/api/client-auth/profile', { full_name: fullName });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update profile' };
    }
  },

  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await clientApi.post('/api/client-auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to change password' };
    }
  },
};

export default clientAuthService;
